import { companyAuthFetch, extractData } from './server';

export const generatePartyBusinessCard = (companyId, partyId) =>
  companyAuthFetch
    .post(`/i-companies/${companyId}/party/${partyId}/business-card`)
    .then(extractData);
